import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import axios from 'axios';
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { TabContext } from '../../../../contexts/TabContext'
import { toastConfig } from '../../../../utils/ToastConfig'
import './FacultyUpdate.css'

const FACULTY_URL = '/faculty/'

const FacultySchema = Yup.object().shape({
    name: Yup.string().required('required'),
    courses_handled: Yup.array().of(Yup.string().min(3, "too short").required('required')),
    qualifications: Yup.array().of(Yup.string().min(3, "too short").required('required')),
    areas_of_interest: Yup.array().of(Yup.string().min(3, "too short").required('required')),
    work_experience: Yup.array().of(Yup.string().min(3, "too short").required('required')),
    papers_published: Yup.array().of(Yup.string().min(3, "too short").required('required')),
    nature_of_association: Yup.string().min(3, "too short").required('required'),
    joining_date: Yup.string().min(3, "too short").required('required'),
    professional_memberships: Yup.array().of(Yup.string().min(3, "too short").required('required')),
    additional_links: Yup.array().of(Yup.object(
        {
            title: Yup.string().min(3, "too short").required('required'),
            link: Yup.string().min(3, "too short").required('required')
        }))
});


const FacultyUpdate = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [faculty, setFaculty] = useState(null)
    const [gettingdata, setGettingdata] = useState(true)
    const [facultyToken, setFacultyToken] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [previewImg, setPreviewImg] = useState()

    const { updateDropdownTab } = useContext(TabContext);

    const getFaculty = async () => {
        setGettingdata(true)
        try {
            const response = await axios.get(process.env.REACT_APP_DEPT_API + FACULTY_URL + '/' + id)
            setFaculty(response.data)
            setGettingdata(false)
        } catch (err) {
            toast.error(err, toastConfig)
        }
    }
    useEffect(() => {
        async function checkAccess() {
            const facultyToken = localStorage.getItem('faculty_token')
            const facultyId = localStorage.getItem('user_id')
            if (!facultyToken || facultyId !== id) {
                alert('Acess denied')
                navigate('/')
            }
            setFacultyToken(facultyToken)
        }
        checkAccess()
        getFaculty()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setPreviewImg(faculty && faculty.photo && faculty.photo.url)
    }, [faculty])


    return (
        <div className='admin'>
            <ToastContainer
                position="bottom-right"
                autoClose={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                theme="colored"
            />
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link onClick={() => updateDropdownTab(2)} to="/people" className='breadcrumb__link'>
                            Faculty
                        </Link>
                        <Link to={`/faculty/${id}`} className='breadcrumb__link'>
                            {faculty && faculty.name}
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Edit Profile
                        </Link>
                    </Breadcrumbs>
                </div>
                <h1 className='section__header'>Update Faculty Profile</h1>
                {!gettingdata && faculty ?
                    <Formik
                        initialValues={{ ktu_id: "", contact_no: "", ...faculty }}
                        enableReinitialize={true}
                        validationSchema={FacultySchema}
                        onSubmit={async (data) => {
                            setSubmitting(true)
                            try {
                                await FacultySchema.validate(data)
                                axios.put(process.env.REACT_APP_DEPT_API + FACULTY_URL + id + '/auth/update', data, {
                                    headers: {
                                        authorization: `Bearer ${facultyToken}`
                                    }
                                }).then(() => {
                                    toast.success("Profile Updated", toastConfig)
                                    setSubmitting(false)
                                    setTimeout(() => {
                                        navigate(`/faculty/${id}`)
                                    }, 2500)
                                }).catch(err => {
                                    alert(err.response.data.message && err.response.data.message.message)
                                })
                            } catch (err) {
                                console.log(err)
                                toast.error("Error - Fill all required fields and remove empty values if any", toastConfig)
                            }
                        }}
                    >
                        {({ values, setFieldValue, errors, submitForm }) => (
                            < Form style={{ width: '100%' }}>
                                <button type='button' className='admin_btn_update' disabled={submitting}
                                    onClick={
                                        () => {
                                            if (errors && Object.keys(errors).length !== 0) {
                                                toast.error("Error - Complete all required fields or Remove any empty values", toastConfig)
                                            }
                                            submitForm()
                                        }
                                    }>
                                    <FaSave /> {submitting ? "Saving..." : "Save Changes"}
                                </button>
                                <div className='cpu-container'>
                                    <div className='fpu-col1'>
                                        <div className='cpu-card fpu-personal-card'>
                                            <h2>Personal Details</h2>
                                            <div className='fpu-personal-card-img'>
                                                {previewImg &&
                                                    <div>
                                                        <img src={previewImg && previewImg} alt="profile" />
                                                        <div className='photo-delete-div'>
                                                            <button
                                                                type="button"
                                                                className='photo-delete-btn'
                                                                onClick={() => {
                                                                    setFieldValue("updated_photo", "deleted")
                                                                    setPreviewImg(null)
                                                                }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </div>}
                                                <div className='admin_input_container'>
                                                    <p className="admin_label" htmlFor="updated_photo">Change Profile Image</p>
                                                    <p className='admin_label_small' htmlFor="updated_photo">Allowed formats: [.png, .jpeg, .jpg, .svg, .ico, .jfif, .webp] </p>
                                                    <p className='admin_label_small' htmlFor="updated_photo">Max size: 10MB </p>
                                                    <label className='fpu-file-btn'>
                                                        <input className="admin_input" id="file" name="updated_photo" type="file" onChange={(e) => {
                                                            // converting image to base64 for cloudinary
                                                            const file = e.target.files[0]
                                                            const reader = new FileReader()
                                                            reader.readAsDataURL(file)
                                                            reader.onloadend = () => {
                                                                setFieldValue("updated_photo", reader.result)
                                                                setPreviewImg(reader.result)
                                                            }
                                                        }} />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="name">Name *</label>
                                                <Field className="admin_input" name="name" placeholder="name" />
                                                <ErrorMessage name="name" component="div" className="field-error admin_error_msg" />
                                            </div>

                                            <div className="admin_input_container">
                                                <p className="admin_label">Email: <span>{faculty && faculty.email}</span></p>

                                            </div>
                                            <div className="admin_input_container">
                                                <p className="admin_label">Designation: <span>{faculty && faculty.designation}</span></p>
                                            </div>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="ktu_id">KTU ID</label>
                                                <Field className="admin_input" type="text" name="ktu_id" />
                                            </div>
                                            <div className="admin_input_container">
                                                <label className="admin_label" htmlFor="contact_no">Contact Number</label>
                                                <Field className="admin_input" type="text" name="contact_no" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='cpu-col2'>
                                        <div className='cpu-card'>
                                            <h2>Academic Details</h2>
                                            <div className='fpu-academic-row1'>
                                                <div className='fpu-academic-row1-col'>
                                                    <div className="admin_input_container">
                                                        <label className="admin_label" htmlFor="joining_date">Joining Date</label>
                                                        <Field className="admin_input" type="text" name="joining_date" />
                                                        <ErrorMessage name="joining_date" component="div" className="field-error admin_error_msg" />
                                                    </div>
                                                    <div className="admin_input_container">
                                                        <label className="admin_label" htmlFor="nature_of_association">Nature of Association</label>
                                                        <Field className="admin_input" type="text" name="nature_of_association" />
                                                        <ErrorMessage name="nature_of_association" component="div" className="field-error admin_error_msg" />
                                                    </div>
                                                    <h4>Courses Handled</h4>
                                                    <FieldArray id="courses_handled" name="courses_handled">
                                                        {({ insert, remove, push }) => (
                                                            <div>
                                                                {values.courses_handled && values.courses_handled.length > 0 &&
                                                                    values.courses_handled.map((member, index) => (
                                                                        <div className="fpu-academic-sub-row" key={index}>
                                                                            <div className="admin_input_container">
                                                                                <Field
                                                                                    name={`courses_handled.${index}`}
                                                                                    type="text"
                                                                                    className="admin_input"
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`courses_handled.${index}`}
                                                                                    component="div"
                                                                                    className="field-error admin_error_msg"
                                                                                />
                                                                            </div>
                                                                            <div className="fpu-academic-sub-row-col2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="secondary"
                                                                                    onClick={() => remove(index)}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                <button
                                                                    type="button"
                                                                    className="fpu-add-btn"
                                                                    onClick={() => push('')}
                                                                >
                                                                    Add Course
                                                                </button>
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </div>
                                                <div className='fpu-academic-row1-col'>
                                                    <h4>Areas of Interest</h4>
                                                    <FieldArray name="areas_of_interest">
                                                        {({ insert, remove, push }) => (
                                                            <div>
                                                                {values.areas_of_interest && values.areas_of_interest.length > 0 &&
                                                                    values.areas_of_interest.map((member, index) => (
                                                                        <div className="fpu-academic-sub-row" key={index}>
                                                                            <div className="admin_input_container">
                                                                                <Field
                                                                                    name={`areas_of_interest.${index}`}
                                                                                    type="text"
                                                                                    className="admin_input"
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`areas_of_interest.${index}`}
                                                                                    component="div"
                                                                                    className="field-error admin_error_msg"
                                                                                />
                                                                            </div>
                                                                            <div className="fpu-academic-sub-row-col2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="secondary"
                                                                                    onClick={() => remove(index)}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                <button
                                                                    type="button"
                                                                    className="fpu-add-btn"
                                                                    onClick={() => push('')}
                                                                >
                                                                    Add Area of Interest
                                                                </button>
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </div>
                                            </div>
                                            <div className='fpu-academic-row2-col'>
                                                <div>
                                                    <h4>Qualifications</h4>
                                                    <FieldArray name="qualifications">
                                                        {({ insert, remove, push }) => (
                                                            <div>
                                                                {values.qualifications && values.qualifications.length > 0 &&
                                                                    values.qualifications.map((member, index) => (
                                                                        <div className="fpu-academic-sub-row" key={index}>
                                                                            <div className="fpu-academic-sub-row-col1">
                                                                                <Field
                                                                                    name={`qualifications.${index}`}
                                                                                    type="text"
                                                                                    className="admin_input"
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`qualifications.${index}`}
                                                                                    component="div"
                                                                                    className="field-error admin_error_msg"
                                                                                />
                                                                            </div>
                                                                            <div className="fpu-academic-sub-row-col2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="secondary"
                                                                                    onClick={() => remove(index)}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                <button
                                                                    type="button"
                                                                    className="fpu-add-btn"
                                                                    onClick={() => push('')}
                                                                >
                                                                    Add Qualification
                                                                </button>
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </div>
                                                <div>
                                                    <h4>Work Experience</h4>
                                                    <FieldArray name="work_experience">
                                                        {({ insert, remove, push }) => (
                                                            <div>
                                                                {values.work_experience && values.work_experience.length > 0 &&
                                                                    values.work_experience.map((member, index) => (
                                                                        <div className="fpu-academic-sub-row" key={index}>
                                                                            <div className="admin_input_container">
                                                                                <Field
                                                                                    name={`work_experience.${index}`}
                                                                                    type="text"
                                                                                    className="admin_input"
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`work_experience.${index}`}
                                                                                    component="div"
                                                                                    className="field-error admin_error_msg"
                                                                                />
                                                                            </div>
                                                                            <div className="fpu-academic-sub-row-col2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="secondary"
                                                                                    onClick={() => remove(index)}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                <button
                                                                    type="button"
                                                                    className="fpu-add-btn"
                                                                    onClick={() => push('')}
                                                                >
                                                                    Add Experience
                                                                </button>
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </div>
                                                <div>
                                                    <h4>Publications</h4>
                                                    <FieldArray name="papers_published">
                                                        {({ insert, remove, push }) => (
                                                            <div>
                                                                {values.papers_published && values.papers_published.length > 0 &&
                                                                    values.papers_published.map((member, index) => (
                                                                        <div className="fpu-academic-sub-row" key={index}>
                                                                            <div className="admin_input_container">
                                                                                <Field
                                                                                    name={`papers_published.${index}`}
                                                                                    type="text"
                                                                                    className="admin_input"
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`papers_published.${index}`}
                                                                                    component="div"
                                                                                    className="field-error admin_error_msg"
                                                                                />
                                                                            </div>
                                                                            <div className="fpu-academic-sub-row-col2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="secondary"
                                                                                    onClick={() => remove(index)}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                <button
                                                                    type="button"
                                                                    className="fpu-add-btn"
                                                                    onClick={() => push('')}
                                                                >
                                                                    Add Paper
                                                                </button>
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </div>
                                                <div>
                                                    <h4>Professional Memberships</h4>
                                                    <FieldArray name="professional_memberships">
                                                        {({ insert, remove, push }) => (
                                                            <div>
                                                                {values.professional_memberships && values.professional_memberships.length > 0 &&
                                                                    values.professional_memberships.map((member, index) => (
                                                                        <div className="fpu-academic-sub-row" key={index}>
                                                                            <div className="admin_input_container">
                                                                                <Field
                                                                                    name={`professional_memberships.${index}`}
                                                                                    type="text"
                                                                                    className="admin_input"
                                                                                />
                                                                                <ErrorMessage
                                                                                    name={`professional_memberships.${index}`}
                                                                                    component="div"
                                                                                    className="field-error admin_error_msg"
                                                                                />
                                                                            </div>
                                                                            <div className="fpu-academic-sub-row-col2">
                                                                                <button
                                                                                    type="button"
                                                                                    className="secondary"
                                                                                    onClick={() => remove(index)}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                <button
                                                                    type="button"
                                                                    className="fpu-add-btn"
                                                                    onClick={() => push('')}
                                                                >
                                                                    Add Professional Membership
                                                                </button>
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </div>
                                                <div >
                                                    <h4>Additional Links</h4>
                                                    <FieldArray name="additional_links">
                                                        {({ insert, remove, push }) => (
                                                            <div>
                                                                {values.additional_links && values.additional_links.length > 0 &&
                                                                    values.additional_links.map((sm, index) => (
                                                                        <div className="cpu-sm-sub-row" key={index}>
                                                                            <div className='cpu-sm-sub-row-col'>
                                                                                <div className="admin_input_container">
                                                                                    <label htmlFor={`additional_links.${index}.title`}>Title to Display</label>
                                                                                    <Field
                                                                                        name={`additional_links.${index}.title`}
                                                                                        type="text"
                                                                                        className="admin_input"
                                                                                    />
                                                                                    <ErrorMessage
                                                                                        name={`additional_links.${index}.title`}
                                                                                        component="div"
                                                                                        className="field-error admin_error_msg"
                                                                                    />
                                                                                </div>
                                                                                <div className="admin_input_container">
                                                                                    <label htmlFor={`additional_links.${index}.link`}>Link</label>
                                                                                    <Field
                                                                                        name={`additional_links.${index}.link`}
                                                                                        type="text"
                                                                                    />
                                                                                    <ErrorMessage
                                                                                        name={`additional_links.${index}.link`}
                                                                                        component="div"
                                                                                        className="field-error admin_error_msg"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className='cpu-sm-sub-row-col'>
                                                                                <button
                                                                                    type="button"
                                                                                    className="secondary"
                                                                                    onClick={() => remove(index)}
                                                                                >
                                                                                    <FaTrashAlt />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                <button
                                                                    type="button"
                                                                    className="fpu-add-btn"
                                                                    onClick={() => push({ title: '', link: '' })}
                                                                >
                                                                    Add Link
                                                                </button>
                                                            </div>
                                                        )}
                                                    </FieldArray>
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </Form>
                        )}
                    </Formik>
                    :
                    <p>Loading...</p>
                }
            </div>
        </div >
    )
}

export default FacultyUpdate